export default "__VITE_ASSET__CUR9PJsQ__"